import { useState } from 'react';

import BreadcrumbComponent from '@/components/breadcrumb';
import EditDialog from '@/components/dialogs/edit-dialog';
import StudentsDataTable from '@/components/students/data-table';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

import DeleteStudentAlert from '@/components/dialogs/delete-student-alert';
import StudentPayment from '@/components/dialogs/student-payment';
import StudentEdit from '@/components/students/edit';
import { useMainContext } from '@/context/main-context';
import { hasPaidThisMonth } from '@/lib/utils';

function Students() {
  const {
    students,
    groups,
    openStudentPayment,
    openStudentDelete,
    openStudentEdit,
    toggleModal,
  } = useMainContext();
  const [id, setId] = useState('');
  const [filter, setFilter] = useState('all');

  const student = students.find((s) => s.id === id);
  const studentGroups = groups.filter((group) => group?.students?.includes(id));

  const handleChange = (value) => {
    setFilter(value);
  };

  const filteredStudents = () => {
    switch (filter) {
      case 'paid':
        const paidStudents = students.filter((student) =>
          hasPaidThisMonth(student.paymentHistory)
        );
        return paidStudents;

      case 'notPaid':
        const notPaidStudents = students.filter(
          (student) => !hasPaidThisMonth(student.paymentHistory)
        );
        return notPaidStudents;

      default:
        return students;
    }
  };

  return (
    <div className="px-4 lg:px-8 mx-auto my-4 space-y-2">
      <BreadcrumbComponent title="O'quvchilar ro'yxati" />

      <EditDialog
        id={id}
        open={openStudentEdit}
        setOpen={(value) => toggleModal('openStudentEdit', value)}
      >
        <StudentEdit
          id={id}
          setCloseDialog={(value) => toggleModal('openStudentEdit', value)}
        />
      </EditDialog>

      <DeleteStudentAlert
        id={id}
        open={openStudentDelete}
        setOpen={(value) => toggleModal('openStudentDelete', value)}
      />

      <StudentPayment
        student={student}
        groups={studentGroups}
        open={openStudentPayment}
        setOpen={(value) => toggleModal('openStudentPayment', value)}
      />

      <div>
        <h2 className="text-2xl font-bold tracking-tight">
          Barcha o'quvchilar.
        </h2>
        <p className="text-muted-foreground">
          O'quvchilar ro'yxatini osongina boshqaring va ko'ring.
        </p>
      </div>

      <StudentsDataTable
        id={id}
        setId={setId}
        data={filteredStudents()}
        setOpenDelete={(value) => toggleModal('openStudentDelete', value)}
        setOpenEdit={(value) => toggleModal('openStudentEdit', value)}
        setOpenPayment={(value) => toggleModal('openStudentPayment', value)}
      >
        <div className="flex items-center gap-2">
          <Select value={filter} onValueChange={handleChange}>
            <SelectTrigger className="md:w-44">
              <SelectValue placeholder="Select" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Barchasi</SelectItem>
              <SelectItem value="paid">To'lov qilganlar</SelectItem>
              <SelectItem value="notPaid">To'lov qilmaganlar</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </StudentsDataTable>
    </div>
  );
}

export default Students;
